import { ApiError } from '../../../../lib/api-error';

export type NodeCrudFailureToast = {
  message: string;
  options: { reportError: false };
};

/**
 * React Query owns both Sentry capture and user-error toasts for node CRUD
 * mutations. Local fallback toasts should only fill UX gaps without creating a
 * second low-context Sentry issue.
 */
export function getNodeCrudFailureToast(
  error: unknown,
  fallbackMessage: string
): NodeCrudFailureToast | null {
  if (error instanceof ApiError && error.userError) return null;
  return { message: fallbackMessage, options: { reportError: false } };
}

export function getNodeUpdateFailureToast(error: unknown): NodeCrudFailureToast | null {
  return getNodeCrudFailureToast(error, 'Failed to update node');
}
